<template>
    <cropper :img="imgEkstraUrl"/>
</template>

<script>
    import Cropper from "@/components/Cropper"

    export default {
        name: "Test",
        data() {
            return {
                imgEkstraUrl: ''
            }
        },
        created() {
            this.imgEkstraUrl = "https://latinize.kizilay.org.tr/api/mektup/ResmiGetir?imageId=y8gNeZtk0eWxYb4mG6izy7UGapQNb2X1oEIEIGWM7JEMrDm"
            var sWidth = "Total Width: " + screen.width;
            var sHeight = "Total Height: " + screen.height;
            alert(sWidth + " " + sHeight)
        },
        components: {
            Cropper,
        }
    }
</script>

<style scoped>

</style>